// import Swiper JS
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
var $swipers = document.querySelectorAll(".swiper");

var swiper = {
  init: function() {

    if(!$swipers.length) return;

    $swipers.forEach((_swiper) => {
      const swiper = new Swiper(_swiper, {
        modules: [Navigation, Pagination],
        spaceBetween: 0,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
  
      document.querySelectorAll(".thumbs__btn").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          var index = btn.getAttribute("data-index");
          swiper.slideTo(index);
        });
      });
  
      swiper.on("slideChange", (e) => onSlideChange(e.activeIndex, _swiper));
      
      document.addEventListener("keyup", (event) => {
        switch (event.code) {
          case "ArrowRight":
            swiper.slideNext();
            break;
          case "ArrowLeft":
            swiper.slidePrev();
            break;
        }
      });
    });
  }
};

function onSlideChange(index, _swiper) {
  const current =  _swiper.querySelector(".thumbs__btn[data-index='" + index + "']");

  if (current) {
    current.classList.add("thumbs__btn--active");
    _swiper.querySelectorAll(".thumbs__btn").forEach((btn) => {
      btn.classList.remove("thumbs__btn--active");
    });
    current.classList.add("thumbs__btn--active");
  }
}

export default swiper;
